import script from "./SettingGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingGuide.vue?vue&type=script&setup=true&lang=js"

import "./SettingGuide.vue?vue&type=style&index=0&id=c0b97840&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0b97840"]])

export default __exports__